import { useContext, useEffect, useState } from 'react';

import RegulamentoLayout from 'components/regulamento-layout';
import TabTitle from 'components/tab-title';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import AvisoDeCicloForaDaTela from 'components/ui/aviso-de-ciclo-fora-da-tela';
import { AuthContext } from 'context/AuthContext';
import { useCicloDaTela } from 'hooks/useCicloDaTela';
import { getFaq } from 'services/content.service';

import FaqItem from './FaqItem';

const qrcode = require('assets/img/qrcode-bbfunci.png');

export default function Faq() {
  const [faqList, setFaqList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const [optionsCycle, setOptionsCycle] = useState<any>([]);

  const { realCycle, user } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      if (!activeItem || !user?.extra) return;
      setLoading(true);
      const data = await getFaq(!!activeItem ? activeItem : '', user?.extra?.rede);
      if (data) {
        setFaqList(data);
      }
      setLoading(false);
    }
    loadData();
  }, [activeItem, user]);

  useEffect(() => {
    if (!realCycle || !user?.extra) return;

    const cycleOptions = realCycle
      .filter((item: any) => (user?.extra?.rede && item?.date_start >= 1706886000000) || (!user?.extra?.rede && item?.date_start >= 1690772400000))
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle, user]);

  // CIC-12: o ciclo do app fora do recorte da Ajuda (antes do 2S2023, ou do 1S2024 na Rede).
  const { foraDaTela, maisRecente, trocar } = useCicloDaTela(optionsCycle);
  const activeCycle = foraDaTela ? undefined : optionsCycle.find((cycle: any) => cycle.value === activeItem);
  const tituloDoCiclo = activeCycle?.title ?? foraDaTela?.title;

  return (
    <RegulamentoLayout title="Ajuda">
      {/* QR Code do atendimento no topo, antes das perguntas (AJH-28). */}
      <div className="mb-4 flex flex-wrap items-center gap-6 rounded-2xl bg-brand-blue px-6 py-[22px] text-brand-white">
        <img
          src={qrcode}
          alt=""
          role="presentation"
          className="box-border h-28 w-28 rounded-lg bg-brand-white p-1.5"
        />
        <div
          className="min-w-[260px] flex-1 text-sm leading-relaxed"
          aria-label="Dúvidas? Digite #JogaJuntoBB e converse com um especialista em dias úteis de 9 às 18h, horário de Brasília"
          tabIndex={0}
        >
          <b className="text-brand-yellow">Dúvidas? Digite #JogaJuntoBB</b>
          <br />e converse com um especialista em dias úteis de 9 às 18h (horário de Brasília)
        </div>
      </div>

      <div className="mb-4 rounded-2xl bg-brand-yellow-light px-6 py-5">
        <p className="m-0 text-sm leading-relaxed text-content" tabIndex={0}>
          Encontre respostas para suas dúvidas rapidamente. Acesse as principais dúvidas dos nossos clientes ou clique na dúvida
          específica do <b className="text-brand-blue">#JOGAJUNTOBB</b>.
        </p>
      </div>

      <div className="mb-3.5 flex flex-wrap items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <h2 className="m-0 font-display text-[19px] font-bold text-brand-blue-dark">FAQ</h2>
          <span className="text-content-soft">|</span>
          {/* `title`, e não o `label` das opções ("Ciclo X"): o texto já põe o "Ciclo" na frente. */}
          <span className="font-display text-[17px] font-bold text-brand-blue">
            {tituloDoCiclo ? `Ciclo ${tituloDoCiclo}` : 'Selecione o ciclo'}
          </span>
        </div>

        {/* `hideLabel` deixa só o seletor: o rótulo "FAQ | Ciclo" acima é o do
            design. O TabTitle fica porque, além de escolher o ciclo inicial,
            é ele quem sincroniza a troca com o `cycleSelected` global. */}
        <TabTitle
          hideLabel
          variant="light"
          title={<></>}
          options={optionsCycle}
          onCallBack={cycle => setActiveItem(cycle.value)}
        />
      </div>

      {foraDaTela && <AvisoDeCicloForaDaTela ciclo={foraDaTela} disponivel={maisRecente} onVer={trocar} />}

      <div hidden={!!foraDaTela} className="flex flex-col gap-2">
        {!!loading && (
          <>
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </>
        )}

        {!loading &&
          !!faqList &&
          faqList.map((item: any) => (
            <FaqItem key={item._id} _id={item._id} title={item.title} />
          ))}
      </div>

    </RegulamentoLayout>
  );
}
